import React from 'react';
import { connect } from 'react-redux';
import { bool, object, shape, string } from 'prop-types';
import RelayQueryLookupRenderer from 'relay-query-lookup-renderer';

import Header from '../Header/Header';

let prevProps = {};

function HeaderRenderer(props) {
    const { environment, initialVariables, query, relayVariables } = props;
    const variables = {
        ...initialVariables,
        ...relayVariables
    };

    return (
        <RelayQueryLookupRenderer
            lookup
            environment={environment}
            query={query}
            variables={variables}
            render={({props: rendererProps}) => { // eslint-disable-line react/display-name, react/prop-types
                let currentProps = {
                    ...prevProps,
                    ...variables
                };

                if (rendererProps) {
                    const { serverViewer } = rendererProps;

                    if (serverViewer) {
                        currentProps = {
                            ...currentProps,
                            ...serverViewer
                        };
                    }

                    currentProps = {
                        ...currentProps,
                        ...rendererProps
                    };
                }

                prevProps = currentProps;
                return <Header {...currentProps}/>;
            }}
        />
    );
}

HeaderRenderer.propTypes = {
    environment: object,
    initialVariables: object,
    query: object,
    relayVariables: shape({
        previewKey: string,
        showMarketingMessages: bool
    })
};

const mapStateToProps = ({ header }) => {
    return {
        relayVariables: header.relayVariables || {}
    };
};

export default connect(mapStateToProps)(HeaderRenderer);



// WEBPACK FOOTER //
// ./src/components/HeaderRenderer/HeaderRenderer.jsx